import { ROUTES } from '@/constants/routes';

export const getProfileMenuItems = (
  handleLogout: (event: React.MouseEvent) => void
): {
  href: string;
  translationKey: string;
  dataStat?: string;
  onClick?: (event: React.MouseEvent) => void;
}[] => {
  return [
    { href: ROUTES.profile, translationKey: 'pages.cabinet.my_ads' },
    {
      href: ROUTES.addBalance,
      dataStat: 'desktop-header-add-balance',
      translationKey: 'pages.cabinet.add_private_account',
    },
    { href: ROUTES.bookmarks, translationKey: 'pages.bookmarks.favorites' },
    {
      href: ROUTES.session,
      onClick: handleLogout,
      translationKey: 'common.exit',
    },
  ];
};
